import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { loaiThuBoSungKienThucApi } from "../../../api/category/loaiThuBoSungKienThucApi";
import { IDmLoaiThuBoSungKienThucRequest } from "../../../model/request/category/dmLoaiThuBoSungKienThucRequest";
import { IDmLoaiThuBoSungKienThuc } from "../../../model/respone/category/IDmLoaiThuBoSungKienThuc";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDmLoaiThuBoSungKienThucActionIds,
  IDmLoaiThuBoSungKienThucActionTypes,
} from "../../action-types/category/IDmLoaiThuBoSungKienThucActions";
import { rootActions } from "../../actions/rootActions";
import { IHeNganhBoSungKienThuc } from "../../reducer-model/category/IDmLoaiThuBoSungKienThucReducer";

export function* loaiThuBoSungKienThucSaga(): any {
  yield takeLatest(eDmLoaiThuBoSungKienThucActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmLoaiThuBoSungKienThucActionIds.SAVE_START, saveWorker);
  yield takeEvery(eDmLoaiThuBoSungKienThucActionIds.DELETE_START, deleteWorker);
  yield takeEvery(
    eDmLoaiThuBoSungKienThucActionIds.DELETE_MANY_START,
    deleteManyWorker,
  );
  yield takeLatest(
    eDmLoaiThuBoSungKienThucActionIds.LOAD_HE_NGANH_START,
    loadHeNganhsWorker,
  );
  yield takeEvery(
    eDmLoaiThuBoSungKienThucActionIds.SAVE_MULTIPLE_START,
    insertMultipleWorker,
  );
  yield takeLatest(
    eDmLoaiThuBoSungKienThucActionIds.LOAD_THEO_DOT_START,
    loadByDotWorker,
  );
}

function* loadWorker(action: IDmLoaiThuBoSungKienThucActionTypes): any {
  const res: IBaseRespone = yield call(
    loaiThuBoSungKienThucApi.SelectViewModelAll,
  );
  if (res.is_success) {
    yield put(
      rootActions.category.loaiThuBoSungKienThuc.LOAD_SUCCESS(res.data),
    );
  } else {
    yield put(
      rootActions.category.loaiThuBoSungKienThuc.LOAD_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}

function* saveWorker(action: IDmLoaiThuBoSungKienThucActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IDmLoaiThuBoSungKienThuc;
  if (payload.id_thu_chi_main > 0) {
    res = yield call(loaiThuBoSungKienThucApi.Update, payload);
  } else {
    res = yield call(loaiThuBoSungKienThucApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(
        rootActions.category.loaiThuBoSungKienThuc.SAVE_SUCCESS(res.data),
      );
    } else {
      yield put(
        rootActions.category.loaiThuBoSungKienThuc.SAVE_ERROR(
          res.message ?? "Có lỗi",
        ),
      );
    }
  }
}

function* deleteWorker(action: IDmLoaiThuBoSungKienThucActionTypes): any {
  const res: IBaseRespone = yield call(
    loaiThuBoSungKienThucApi.Delete,
    action.payload as number,
  );
  if (res.is_success) {
    yield put(
      rootActions.category.loaiThuBoSungKienThuc.DELETE_SUCCESS(res.data),
    );
  } else {
    yield put(
      rootActions.category.loaiThuBoSungKienThuc.DELETE_ERROR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}

function* deleteManyWorker(action: IDmLoaiThuBoSungKienThucActionTypes): any {
  const res: number = yield call(
    loaiThuBoSungKienThucApi.DeleteMany,
    action.payload as number[],
  );
  if (res > 0) {
    yield put(
      rootActions.category.loaiThuBoSungKienThuc.DELETE_MANY_SUCCESS(undefined),
    );
  } else {
    yield put(
      rootActions.category.loaiThuBoSungKienThuc.DELETE_MANY_ERROR("Có lỗi"),
    );
  }
}

function* loadHeNganhsWorker(action: IDmLoaiThuBoSungKienThucActionTypes): any {
  const res: IBaseRespone = yield call(
    loaiThuBoSungKienThucApi.SelectHeNganhs,
    action.payload as IDmLoaiThuBoSungKienThucRequest,
  );
  if (res.is_success) {
    yield put(
      rootActions.category.loaiThuBoSungKienThuc.LOAD_HE_NGANH_SUCCESS(
        res.data as IHeNganhBoSungKienThuc[],
      ),
    );
  } else {
    yield put(
      rootActions.category.loaiThuBoSungKienThuc.LOAD_HE_NGANH_ERRR("Có lỗi"),
    );
  }
}

function* insertMultipleWorker(
  action: IDmLoaiThuBoSungKienThucActionTypes,
): any {
  const res: IBaseRespone = yield call(
    loaiThuBoSungKienThucApi.InsertMultiple,
    action.payload as IDmLoaiThuBoSungKienThuc[],
  );
  if (res.is_success) {
    yield put(
      rootActions.category.loaiThuBoSungKienThuc.SAVE_MULTIPLE_SUCCESS(
        res.data,
      ),
    );
  } else {
    yield put(
      rootActions.category.loaiThuBoSungKienThuc.SAVE_MULTIPLE_ERROR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}
function* loadByDotWorker(action: IDmLoaiThuBoSungKienThucActionTypes): any {
  const res: IBaseRespone = yield call(
    loaiThuBoSungKienThucApi.SelectByDot,
    action.payload as IDmLoaiThuBoSungKienThucRequest,
  );
  if (res.is_success) {
    yield put(
      rootActions.category.loaiThuBoSungKienThuc.LOAD_THEO_DOT_SUCCESS(
        res.data,
      ),
    );
  } else {
    yield put(
      rootActions.category.loaiThuBoSungKienThuc.LOAD_THEO_DOT_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}
